module.exports = __webpack_public_path__ + "static/media/[Annual_Oration]2011.b80caba3.md";